import React from 'react';
import Bulb from './Bulb.png';
import SiteListTop from './SiteListTop.png';
import SiteListBottom from './SiteListBottom.png';
import * as S from './SidePanel.styles';

const SidePanel = () => (
    <S.Container>
        <S.TopImage alt="Right Panel Top Image" src={SiteListTop} />
        <S.InfoDiv>
            <S.BulbImage alt="Bulb Image" src={Bulb}/>
            <S.HeaderDiv>
                We&apos;re always looking to improve.
            </S.HeaderDiv>
            <S.SubHeaderDiv>
                What functionality would you like to see? Let us know.
            </S.SubHeaderDiv>
            <S.TextDiv>
                Go to Support {'>'} Ideas Portal
            </S.TextDiv>
        </S.InfoDiv>
        <S.BottomImage alt="Right Panel Bottom Image" src={SiteListBottom} />
    </S.Container>
);

export default SidePanel;